import React, { useEffect, useState } from 'react';
import Modal from 'react-modal';
// import { GetAndCreateAssignedToMails } from '../../../../services/ProductService/AddProducts/AddProducts';

export default function AssignedToModal({isOpen, onClose, onAssign, AssignedData }) {
    const [assignedEmail, setAssignedEmail] = useState([]);
    const [showPopup, setShowPopup] = useState(false);
    const [inputValue, setInputValue] = useState('');
    const [showSuggestions, setShowSuggestions] = useState(false);
    const [value, setValue] = useState('Not Assigned');
    const [message, setMessage] = useState('');

    const [product_assign, setAssignment] = useState({
        admin_emails: [],
        assigned_to_me: false,
        completed_on: '',
        priority: '',
        comments: '',
    });

    const openPopup = () => setShowPopup(true);
    const closePopup = () => {
        setShowPopup(false);
        setMessage('');
    };

    const handleSelectEmail = (email) => {
        if (!product_assign.admin_emails.includes(email)) {
            setAssignment((prev) => ({
                ...prev,
                admin_emails: [...prev.admin_emails, email],
            }));
        }
        setInputValue('');
        setShowSuggestions(false);
    };

    const handleRemoveEmail = (email) => {
        setAssignment((prev) => ({
            ...prev,
            admin_emails: prev.admin_emails.filter((item) => item !== email),
        }));
    };

    const handleInputChange = (e) => {
        setInputValue(e.target.value);
        setShowSuggestions(true);
    };

    const handleClickOutside = (e) => {
        if (!e.target.closest('.suggestion-container')) {
            setShowSuggestions(false);
        }
    };

    const handleAssign = () => {
        const { admin_emails, completed_on, priority, comments } = product_assign;

        if (
            !product_assign.assigned_to_me &&
            (admin_emails.length === 0 || !completed_on || !priority || !comments)
        ) {
            setMessage('Please fill in all fields before assigning.');
            return;
        }

        onAssign(product_assign);
        setValue('Assigned');
        closePopup();
    };

    useEffect(() => {
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    useEffect(() => {
        // Example fetch function
        // const fetchAssignedEmails = async () => {
        //     try {
        //         const response = await GetAndCreateAssignedToMails('GET', {});
        //         setAssignedEmail(response.data);
        //     } catch (error) {
        //         console.error('Error fetching emails:', error);
        //     }
        // };
        // fetchAssignedEmails();

        // Dummy data
        setAssignedEmail([
            { id: 1, a_email: 'admin@example.com' },
            { id: 2, a_email: 'user@example.com' },
            { id: 3, a_email: 'support@example.com' },
        ]);
    }, []);

    useEffect(() => {
        if (AssignedData) {
            setAssignment((prev) => ({ ...prev, ...AssignedData }));

            if (
                AssignedData.admin_emails?.length > 0 ||
                AssignedData.completed_on ||
                AssignedData.priority ||
                AssignedData.comments
            ) {
                setValue('Assigned');
            }
        }
    }, [AssignedData]);

    return (
        <div>

            <Modal
      isOpen={isOpen}
      onRequestClose={onClose}
                className="bg-white p-6 rounded-lg shadow-lg w-fit mx-auto z-50"
                overlayClassName="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50"
            >
                <div className="border-b border-gray-400 mb-4">
                    <h2 className="text-xl font-semibold text-center">Assigned To</h2>
                </div>

                {/* Assigned to me checkbox */}
                <div className="flex items-center gap-3 mb-4">
                    <input
                        type="checkbox"
                        checked={product_assign.assigned_to_me}
                        onChange={(e) =>
                            setAssignment((prev) => ({
                                ...prev,
                                assigned_to_me: e.target.checked,
                            }))
                        }
                        className="scale-125"
                    />
                    <p>Assigned To me</p>
                </div>

                {/* Assign To Input */}
                <div>
                    <h1 className="text-gray-500 font-bold mb-2">
                        Assign To <span className="text-red-500">*</span>
                    </h1>
                    <div className="relative suggestion-container">
                        <div className="flex items-center gap-2 border border-gray-300 rounded-md bg-blue-50 p-2 h-20 overflow-y-auto flex-wrap">
                            {product_assign.admin_emails.map((email) => (
                                <div key={email} className="bg-blue-100 text-blue-700 px-2 py-1 rounded flex items-center">
                                    {email}
                                    <button
                                        type="button"
                                        onClick={() => handleRemoveEmail(email)}
                                        className="ml-2 text-red-500 hover:text-red-700"
                                    >
                                        ✕
                                    </button>
                                </div>
                            ))}
                            <input
                                type="text"
                                value={inputValue}
                                onChange={handleInputChange}
                                placeholder="Enter email"
                                className="outline-none bg-blue-50 flex-shrink-0 w-40"
                            />
                        </div>
                        {showSuggestions && (
                            <div className="absolute z-10 bg-white border border-gray-300 w-full mt-1 rounded-md shadow-md max-h-40 overflow-y-auto">
                                {assignedEmail
                                    .filter((item) =>
                                        item.a_email.toLowerCase().includes(inputValue.toLowerCase())
                                    )
                                    .map((item) => (
                                        <div
                                            key={item.id}
                                            onClick={() => handleSelectEmail(item.a_email)}
                                            className="p-2 cursor-pointer hover:bg-blue-100"
                                        >
                                            {item.a_email}
                                        </div>
                                    ))}
                            </div>
                        )}
                    </div>
                </div>

                {/* Completed By & Priority */}
                <div className="flex justify-between gap-5 mt-4">
                    <div>
                        <h1 className="font-semibold mb-2 text-gray-500">Completed By</h1>
                        <input
                            type="date"
                            value={product_assign.completed_on}
                            onChange={(e) =>
                                setAssignment((prev) => ({
                                    ...prev,
                                    completed_on: e.target.value,
                                }))
                            }
                            className="w-52 border border-gray-300 rounded-xl p-3 bg-blue-50 outline-none"
                        />
                    </div>
                    <div>
                        <h1 className="font-semibold mb-2 text-gray-500">Priority</h1>
                        <select
                            value={product_assign.priority}
                            onChange={(e) =>
                                setAssignment((prev) => ({
                                    ...prev,
                                    priority: e.target.value,
                                }))
                            }
                            className="w-52 p-4 border border-gray-300 rounded-xl outline-none bg-blue-50"
                        >
                            <option value="">Select Priority</option>
                            <option value="Low">Low</option>
                            <option value="Medium">Medium</option>
                            <option value="High">High</option>
                        </select>
                    </div>
                </div>

                {/* Comments */}
                <div className="mt-4">
                    <h1 className="font-bold text-gray-500">Comments</h1>
                    <textarea
                        value={product_assign.comments}
                        onChange={(e) =>
                            setAssignment((prev) => ({
                                ...prev,
                                comments: e.target.value,
                            }))
                        }
                        placeholder="Write Comments..."
                        className="border border-gray-300 h-32 w-full mt-2 rounded-xl bg-blue-50 p-2 outline-none"
                    />
                </div>

                {/* Error Message */}
                {message && <p className="text-red-500 mt-2">{message}</p>}

                {/* Action Buttons */}
                <div className="flex justify-end space-x-3 mt-4">
                    <button onClick={onClose} className="px-4 py-2 border rounded">
                        Cancel
                    </button>
                    <button onClick={handleAssign} className="px-4 py-2 bg-blue-500 text-white rounded">
                        Assign
                    </button>
                </div>
            </Modal>
        </div>
    );
}